module.exports = __webpack_public_path__ + "img/gestion-parasitaire-eric-lauze.60a0410c.jpg";